import '../common-init';

import angular from 'angular';

// angular-busy
import 'angular-busy/dist/angular-busy';
import 'angular-busy/dist/angular-busy.css';

// Constants
import constants from '../../lib/constants';

// Component
import staffComponent from './staff.component';

// Load all services
import logServiceModule from '../../lib/service/LogService';
import newRelicServiceModule from '../../lib/service/NewRelicService';
import '../../lib/service';
import dataSyncService from '../../lib/service/DataSyncService';
import globalMessageList from '../../lib/components/globalMessageList';
import appVersionService from '../../lib/service/AppVersionService';
import analyticsService from '../../lib/service/AnalyticsService';
import translationServiceModule from '../../lib/service/TranslationService';

// Translations
import translations from '../../lib/translation';

// Dependencies
import recapResponse from '../recaps/response/response';
import loginScreen from './loginScreen';
import serverSideLoginScreen from './serverSideLoginScreen';
import dashboardScreen from './dashboardScreen';
import editProfile from './editProfile';
import eventProductEntry from './eventProductEntry';
import appVersionLabel from '../../lib/components/appVersionLabel';
import appVersionUpdateModalModule from '../../lib/components/modals/appVersionUpdateModal';
import appVersionUpdateCompleteModalModule from '../../lib/components/modals/appVersionUpdateCompleteModal';
import languageSelector from '../../lib/components/languageSelector';
import syncWindowSelector from '../../lib/components/syncWindowSelector';
import offlineModeSelector from '../../lib/components/offlineModeSelector';

const moduleName = 'staff';
let module = angular.module(moduleName, [
  logServiceModule.name,
  newRelicServiceModule.name,
  'cgBusy',
  constants,
  translations,
  loginScreen.name,
  serverSideLoginScreen.name,
  dashboardScreen.name,
  recapResponse.name,
  editProfile.name,
  eventProductEntry.name,
  dataSyncService.name,
  globalMessageList.name,
  appVersionLabel.name,
  appVersionService.name,
  appVersionUpdateModalModule.name,
  appVersionUpdateCompleteModalModule.name,
  languageSelector.name,
  syncWindowSelector.name,
  offlineModeSelector.name,
  analyticsService.name,
  translationServiceModule.name,
]);

module.component('fieldStaffApp', staffComponent);

// module.config ($animateProvider =>{
//  //$animateProvider.classNameFilter(/\banimate\b/);
//  //$animateProvider.classNameFilter(/^(?:(?!no-animate).)*$/);
// });
export default module;
